import { render, staticRenderFns } from "./PcHeader.vue?vue&type=template&id=588f9e1f"
import script from "./PcHeader.vue?vue&type=script&lang=js"
export * from "./PcHeader.vue?vue&type=script&lang=js"
import style0 from "./PcHeader.vue?vue&type=style&index=0&id=588f9e1f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports